import { render } from "./CitesComponent.vue?vue&type=template&id=1cfc4a39&ts=true"
import script from "./CitesComponent.vue?vue&type=script&lang=ts"
export * from "./CitesComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__